import { Reducer } from 'typesafe-actions';
import { ApiError } from '@types';

export type ErrorState = {
    errors: ApiError[];
};
export const initialState: ErrorState = {
    errors: []
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const errors: Reducer<ErrorState, any> = (state: ErrorState = initialState, action = {}) => {
    const failure = action.type.endsWith('FAILURE');

    switch (failure || action.type) {
        case failure:
            return {
                ...state,
                errors: [...state.errors, action.type]
            };
        case 'SET_NOTIFICATION':
            return {
                ...state,
                errors: [...state.errors, action.payload]
            };
        case 'DISMISS_NOTIFICATION':
            return {
                ...state,
                errors:
                    action.payload != '' && state.errors && state.errors.length
                        ? state.errors.filter((error: ApiError) => error.id !== action.payload)
                        : []
            };
        default:
            break;
    }
    return state;
};
